$(document).ready(function () {

  // MAKE SECTION DRAG SCROLLING STARTS
  $('.drag-scrolling').each(function () {
    dragScrolling(this);
  });

  function dragScrolling(className) {
    const slider = className;
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      slider.scrollLeft = scrollLeft - (e.pageX - startX) *2;
    });
  }
  // MAKE SECTION DRAG SCROLLING ENDS 

  // TOPBAR HEADER STARTS 
  $(this).scroll(function () { 
    if($(this).scrollTop()){
      $('.top-bar').addClass('shrinked');
    }
    else{
      $('.top-bar').removeClass('shrinked');
    }
  });
  // TOPBAR HEADER ENDS
  
  // TOGGLE NAVIGATION FOR SMALL DEVICES STARTS 
  $('.toggle-navigation').click(function() {
    $('.navigation').addClass('navigation-active');
  });
  $('.close-navigation').click(function() {
    $('.navigation').removeClass('navigation-active');
  });
  $('.navigation').click(function(event) { 
    var $target = $(event.target);
    if(!$target.closest('.top-navbar').length) {
      $(this).removeClass('navigation-active');
    }        
  });
  // TOGGLE NAVIGATION FOR SMALL DEVICES ENDS

  // PROMO SECTION FOR SMALL DEVICES STARTS
  $('.promolist-sm-wrapper').owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    autoplay: true,
    smartSpeed: 500,
    autoplaySpeed: 500,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1
      }
    }
  });
  // PROMO SECTION FOR SMALL DEVICES ENDS

  // TABBED MENU STARTS 
  $('[data-label^="tab-"]').click(function(e) {
    var targetName = $(this).attr('data-label');
    $(this).parents('[data-role="tab-menu"]').find('[data-label^="tab-"]').removeClass('active');
    $(this).addClass('active');
    $(this).parents('[data-role="tab-menu"]').find('[data-target^="tab-"]').removeClass('active');
    $(this).parents('[data-role="tab-menu"]').find(`[data-target="${targetName}"]`).addClass('active');
    e.preventDefault();
  });
  // TABBED MENU ENDS 



  // FOOTER SECTION STARTS
  $('.footer-section-btn').click(function() {
    if($(this).parents('.footer-grid-item').find('.footer-section-body').hasClass('footer-collapsed')){
      $(this).parents('.footer-grid-item').find('.footer-section-body').removeClass('footer-collapsed');
      $(this).find('.btn-icon').html('-');
    }
    else{
      $(this).parents('.footer-grid-item').find('.footer-section-body').addClass('footer-collapsed');
      $(this).find('.btn-icon').html('+');
    }
  });
  // FOOTER SECTION ENDS

  // OFFER SECTION COUNTDOWN STARTS 
  var countDownDate = new Date("Nov 30, 2024").getTime();

  var myfunc = setInterval(function() {
    // code goes here
    var now = new Date().getTime();
    var timeleft = countDownDate - now;
        
    var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
    $('.offer-hour').html(hours);
    $('.offer-min').html(minutes);
    $('.offer-sec').html(seconds);
  
    if (timeleft < 0) {
      clearInterval(myfunc);
    }
  }, 1000);

  // OFFER SECTION COUNTDOWN ENDS 

  // SEARCHABLE INPUT FUNCTION STARTS
  $('[data-role="searchable-input"]').on('input', function() {
    var searchableArea = $(this).parents('[data-role="searchable-area"]');
    var searchableChilds = searchableArea.find($(this).attr('data-child-name')).not('[data-label="searchable-input-container"]');
    var searchedKeywords = $(this).val().toLowerCase();
    searchableChilds.each(function() {
      if($(this).text().toLowerCase().search(searchedKeywords) != -1){
        $(this).removeClass('d-none');
      }
      else{
        $(this).addClass('d-none');
      }
    });    
  });
  // SEARCHABLE INPUT FUNCTION ENDS

  // PRODUCT CARDS CAROUSEL STARTS 
  $('.cards-grid').owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    autoplay: true,
    smartSpeed: 1000,
    autoplaySpeed: 1000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 2.1
      },
      565: {
        items: 3.3
      },
      992: {
        items: 3.6
      },
      1024: {
        items: 4.5
      },
      1200: {
        items: 5.5
      },
      1800:{
        items: 6.5
      }
    }
  });
  // PRODUCT CARDS CAROUSEL ENDS
$(".top-tab").hide();
  $(".tab1").show();
  //buttons get id
  $("button").click(function() {
    // alert("."+this.id);
    $(".top-tab").hide();
       // fixes added for add to cart button on product page
    if(this.id != ''){
      $("."+this.id).fadeIn();
    }else{
      if(this.name != 'checkout'){
           setTimeout(
        function() 
        {
          location.reload();
        }, 1000);
      }
    
      
    }
  });

});

